export default "__VITE_ASSET__d1f841c8__"